import { Actions } from '../actions/gateways';
import { Gateway } from '../types/samples';

interface GatewaysBySiteId {
  [key: number]: Gateway[];
}

const initialState: GatewaysBySiteId = {};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case Actions.GATEWAYS_SUCCESS: {
      const { siteId, gateways } = action.payload;
      if (!siteId) return state;
      return {
        ...state,
        [siteId]: gateways,
      };
    }

    default:
      return state;
  }
};
